import type React from "react";

import { toast } from "@/components/ui/toast";
import { useSetDialogState } from "../components/detail/state";

export function useFileDrop() {
  const setDialogState = useSetDialogState("upload");

  const errorToast = (text: string) => {
    toast.error("Error uploading file", { description: text });
  };

  const onDrop: React.DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();

    const files = e.dataTransfer.files;

    if (!files || files.length === 0) {
      errorToast("No files found.");
      return;
    }
    if (files.length > 1) {
      errorToast("Uploading multiple files is not supported.");
      return;
    }

    const file = files[0];

    setDialogState({ files: [file] });
  };

  const onDragOver: React.DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return { onDrop, onDragOver };
}
